var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9285 10.9283L1.74941 10.9283C1.37436 10.9283 1.07127 11.2313 1.07127 11.6064C1.07128 11.9815 1.37437 12.2845 1.74942 12.2845L10.9285 12.2846L10.9275 21.4647L10.9275 21.4648C10.9275 21.8397 11.2304 22.1427 11.6053 22.1429C11.9817 22.1441 12.2859 21.8398 12.2859 21.4648L12.2859 12.2857L21.466 12.2847C21.841 12.2847 22.1441 11.9816 22.1441 11.6065C22.1441 11.2315 21.84 10.9273 21.4649 10.9273L21.4649 10.9273L12.2848 10.9283L12.2858 1.7482V1.74818C12.2858 1.37313 11.9827 1.07004 11.6076 1.07004C11.2308 1.07003 10.9284 1.37164 10.9284 1.74709L10.9285 10.9283Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.51a83e105fd26d98107ed9bb38d0f033.svg";
export { ForwardRef as ReactComponent };